import { PageLayout, getPageStatus } from 'components/PageLayout';
import { BroadcastifyFeedDetails } from 'features/broadcastify/components/BroadcastifyFeedDetails';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { useBroadcastifyFeed } from 'features/broadcastify/hooks/useBroadcastifyFeed';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { MEMBERSHIP_PLANS } from 'features/membership/membership.constants';
import { getPaywallLink } from 'features/membership/membership.utils';

export const BroadcastifyFeedPage = (
  props: RouteComponentProps<{ feedId: string; lat: string; lng: string }>,
): JSX.Element => {
  const {
    match: { params },
  } = props;
  const { t } = useTranslation();
  const { showMembershipFeatures } = useAuthState();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');
  const { broadcastifyFeed, isLoading, error } = useBroadcastifyFeed({
    feedId: Number(params.feedId),
    lat: Number(params.lat),
    lng: Number(params.lng),
  });

  if (!showMembershipFeatures) {
    const paywallLink = getPaywallLink({
      focusedPlan: MEMBERSHIP_PLANS.proYearly,
      source: 'broadcastify_feed_page_redirect',
    });
    return <Redirect to={paywallLink.url} />;
  }

  const status = getPageStatus({
    isLoading,
    isError: Boolean(error) || !broadcastifyFeed,
  });

  return (
    <PageLayout
      data-cname="BroadcastifyFeedPage"
      status={status}
      headerBarProps={{ action: 'back' }}
    >
      {broadcastifyFeed && (
        <>
          <Helmet>
            <title>
              {t(pinImprovements ? 'feeds.title' : 'broadcastifyFeed.title', {
                name: broadcastifyFeed.name,
              })}
            </title>
          </Helmet>
          <SimplePageLayout>
            <BroadcastifyFeedDetails {...broadcastifyFeed} />
          </SimplePageLayout>
        </>
      )}
    </PageLayout>
  );
};
